// 会费管理

import { method } from '@/utils/constant'
import request from '@/utils/request'

const { POST, GET } = method

export default {
  // 会费管理列表
  async getPaymentList(params) {
    return request({ method: POST, url: `/admin/payment/admin/list`, params })
  },
  async getFilterTypeList(params) {
    return request({ method: GET, url: `/admin/approval/listQueryCondition` })
  },
  // 欠费通知的统计数
  async getPaymentArrearsAount(params) {
    return request({ method: POST, url: `/admin/payment/admin/arrears/count`, params })
  },
  // 根据会员ID查询缴费详情
  async getPaymentDetail(params) {
    return request({ method: POST, url: `/admin/payment/admin/detail/${params.id}`, params })
  },
  // 批量设置缴费未匹配的EXCel导出
  async setPaymentExport(params) {
    return request({
      method: POST,
      url: `/admin/payment/admin/export/${params.id}`,
      params,
      responseType: 'blob',
    })
  },
  // 缴费通知的统计数
  async getPaymentCount(params) {
    return request({ method: POST, url: `/admin/payment/admin/payment/count`, params })
  },
  // 保存EXCEL 的缴费数据
  async setPaymentSaveExcel(params) {
    return request({ method: POST, url: `/admin/payment/admin/saveExcel/${params.id}`, params })
  },
  // 单独设置缴费
  async savePayment(params) {
    return request({ method: POST, url: `/admin/payment/admin/savePayment`, params })
  },
  // 批量发送欠费通知
  async sendPaymentArrears(params) {
    return request({ method: POST, url: `/admin/payment/admin/sendArrears`, params })
  },
  // 批量发送缴费通知
  async sendPayment(params) {
    return request({ method: POST, url: `/admin/payment/admin/sendPayment`, params })
  },
  // 批量设置缴费EXCEL解析
  async setPaymentUploadExcel(params) {
    return request({ method: POST, url: `/admin/payment/admin/uploadExcel`, params })
  },
  // =======================================快递单据========================================
  // 快递单据列表
  async getCouierList(params) {
    return request({ method: POST, url: `/admin/courier/list`, params })
  },
  // 批量导入
  async bulkimport(params) {
    return request({ method: POST, url: `/admin/courier/bulkimport`, params })
  },
  // 快递详情
  async getCourierDetail(params) {
    return request({ method: GET, url: `/admin/courier/${params.id}` })
  },

  async courierUpate(params) {
    return request({ method: POST, url: `/admin/courier/update`, params })
  },

  async saveCourierBatch(params) {
    return request({ method: POST, url: `/admin/courier/saveBatch`, params })
  },

  async sendCourier(params) {
    return request({ method: POST, url: `/admin/courier/send`, params })
  },

  async getPaymentYearDetail(params) {
    return request({
      method: 'POST',
      url: `/admin/payment/admin/selectNeedPaymentDetail`,
      params,
    })
  },

  async selectPaymentDetail(params) {
    return request({
      method: 'POST',
      url: `/admin/payment/admin/selectPaymentDetail`,
      params,
    })
  },

  async batchPayConfirmMemUsers(params) {
    return request({
      method: 'POST',
      url: `/admin/approval/batchPayConfirmMemUsers`,
      params,
    })
  },
}
